module.exports = __webpack_public_path__ + "img/uli-pro.116992dc.jpg";